import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9cd12be2")

_pushScopeId("data-v-9cd12be2")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = { class: "subtags-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('navbar.tags')), 1),
    _hoisted_3,
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.state.tags, (tag, tIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "general-container",
        key: tIndex
      }, [
        _createVNode("div", null, [
          _withDirectives(_createVNode("div", null, [
            _createVNode("label", {
              class: "tag-label",
              onClick: ($event: any) => ((tag.tagChange = !tag.tagChange), (tag.tagVmodel = tag.name))
            }, _toDisplayString(tag.name) + "*", 9, ["onClick"]),
            _createVNode("button", {
              class: "btn tag-btn-delete",
              onClick: ($event: any) => ($setup.deleteTag(tag.id, tIndex)),
              type: "button"
            }, " ❌ ", 8, ["onClick"])
          ], 512), [
            [_vShow, !tag.tagChange]
          ]),
          _withDirectives(_createVNode("div", null, [
            _withDirectives(_createVNode("input", {
              class: "tag-input-rename",
              "onUpdate:modelValue": ($event: any) => (tag.tagVmodel = $event)
            }, null, 8, ["onUpdate:modelValue"]), [
              [_vModelText, tag.tagVmodel]
            ]),
            _createVNode("button", {
              class: "btn tag-btn-confirm",
              onClick: ($event: any) => ($setup.editTag(tag.id, tag.tagVmodel, tIndex), (tag.name = tag.tagVmodel), (tag.tagChange = !tag.tagChange)),
              type: "button"
            }, " ✔ ", 8, ["onClick"]),
            _createVNode("button", {
              class: "btn tag-btn-delete",
              onClick: ($event: any) => (tag.tagChange = !tag.tagChange),
              type: "button"
            }, " ❌ ", 8, ["onClick"])
          ], 512), [
            [_vShow, tag.tagChange]
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(tag.subTags, (subTag, stIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "subtag",
              key: stIndex
            }, [
              _withDirectives(_createVNode("div", null, [
                _createVNode("label", {
                  class: "subtag-label",
                  onClick: ($event: any) => ((subTag.subTagChange = !subTag.subTagChange), (subTag.subTagVmodel = subTag.name))
                }, _toDisplayString(subTag.name), 9, ["onClick"]),
                _createVNode("label", {
                  class: " subtag-btn-delete",
                  onClick: ($event: any) => ($setup.deleteSubTag(subTag.id, tIndex, stIndex))
                }, "❌", 8, ["onClick"])
              ], 512), [
                [_vShow, !subTag.subTagChange]
              ]),
              _withDirectives(_createVNode("div", null, [
                _withDirectives(_createVNode("input", {
                  class: "subtag-input-rename",
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => (subTag.subTagVmodel = $event)
                }, null, 8, ["onUpdate:modelValue"]), [
                  [_vModelText, subTag.subTagVmodel]
                ]),
                _createVNode("button", {
                  class: "subtag-btn-confirm",
                  onClick: ($event: any) => (
                                $setup.editSubTag(subTag.id, subTag.subTagVmodel, tIndex, stIndex),
                                    (subTag.name = subTag.subTagVmodel),
                                    (subTag.subTagChange = !subTag.subTagChange)
                            ),
                  type: "button"
                }, " ✔ ", 8, ["onClick"]),
                _createVNode("button", {
                  class: "subtag-btn-delete",
                  onClick: ($event: any) => (subTag.subTagChange = !subTag.subTagChange),
                  type: "button"
                }, " ❌ ", 8, ["onClick"])
              ], 512), [
                [_vShow, subTag.subTagChange]
              ])
            ]))
          }), 128))
        ]),
        _createVNode("form", {
          class: "tag-add",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
        }, [
          _withDirectives(_createVNode("input", {
            placeholder: _ctx.$t('placeholder.enterSubtagName'),
            "onUpdate:modelValue": ($event: any) => (tag[$setup.state.inputSubTagName] = $event)
          }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
            [_vModelText, tag[$setup.state.inputSubTagName]]
          ]),
          _createVNode("button", {
            class: "btn btn-create",
            disabled: tag[$setup.state.inputSubTagName] == '',
            onClick: ($event: any) => ($setup.createSubTag(tag.id, tag[$setup.state.inputSubTagName], tIndex)),
            type: "button"
          }, " ➕ ", 8, ["disabled", "onClick"])
        ], 32)
      ]))
    }), 128)),
    _createVNode("form", {
      class: "subtag-add",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _withDirectives(_createVNode("input", {
        type: "text",
        placeholder: _ctx.$t('placeholder.enterTagName'),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.state.inputTagName = $event))
      }, null, 8, ["placeholder"]), [
        [_vModelText, $setup.state.inputTagName]
      ]),
      _createVNode("button", {
        class: "btn btn-create",
        disabled: $setup.state.inputTagName == '',
        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.createTag($setup.state.inputTagName))),
        type: "button"
      }, " ➕ ", 8, ["disabled"])
    ], 32)
  ]))
})